import React, { useEffect, useState } from "react";
import { allEmployeeURL, allDepartmentURL } from "../../../Library/URLs";
import axios from "axios";
import { v4 as uuid } from "uuid";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { Pagination } from "@mui/material";

const Overview = () => {
  const unique_id = uuid();
  const User = useSelector((state) => state.payroll?.User);
  const { companyid } = useParams();
  const [allEmployees, setAllEmployees] = useState([]);
  const [loading, setLoading] = useState(false);

  const [allDepartment, setAllDepartment] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [page, setPage] = useState(1);

  useEffect(() => {
    fetch();
    FetchAllDepartment();
    // eslint-disable-next-line
  }, []);

  const fetch = async () => {
    // console.log('all employee API is call')
    const raw = {
      user_id: User.user_id,
      user_ses_id: User.user_ses_id,
      transaction_id: unique_id,
      company_id: companyid,
    };
    setLoading(true);
    await axios
      .post(allEmployeeURL, raw)
      .then((res) => {
        setLoading(false);
        if (res.data.success === true) {
          setAllEmployees(res.data.data?.reverse());
        }
        console.log("all employee res result", res.data);

        // console.log('length',res.data.employees.length)
      })
      .catch((err) => {
        setLoading(false);
        console.log("error" + err.message);
      });
  };

  const FetchAllDepartment = async () => {
    const data = {
      user_id: User.user_id,
      user_ses_id: User.user_ses_id,
      transaction_id: unique_id,
      company_id: companyid,
    };
    setIsLoading(true);
    await axios
      .post(allDepartmentURL, data)
      .then((res) => {
        setIsLoading(false);
        if (res.data.success === true) {
          setAllDepartment(res.data.data);
          // console.log('all depart',res.data)
        }
        // console.log('all department res',res.data)
      })
      .catch((err) => {
        // console.log('Get all department error',err.message)
        setIsLoading(false);
      });
  };

  const handleChange = (event, value) => {
    setPage(value);
  };

  const currentItems = allEmployees?.slice(
    (page - 1) * 5,
    page * 5
  );
  const totalPages = Math.ceil(allEmployees?.length / 5);

  return (
    <div>
      <div className="Top_Cards">
        <InfoCard label={"Total Employees"} value={allEmployees?.length} />
        <InfoCard label={"Total Departments"} value={allDepartment?.length} />
      </div>
      <div className="Table_Contain">
        <table>
          <thead>
            <tr>
              <th>Name</th>
              <th>Gender</th>
              <th>Phone no</th>
              <th>Email</th>
            </tr>
          </thead>
          <tbody>
            {currentItems?.map((employee) => (
              <tr key={employee?.id}>
                <td>
                  {employee?.first_name} {employee?.last_name}{" "}
                </td>
                <td>{employee?.gender} </td>
                <td>{employee?.phone_number} </td>
                <td>{employee?.work_email_address} </td>
              </tr>
            ))}
          </tbody>
        </table>
        {allEmployees?.length > 0 && (
          <div className="Paginate_contain">
            <Pagination
              count={totalPages}
              page={page}
              onChange={handleChange}
            />
          </div>
        )}
      </div>
    </div>
  );
};

const InfoCard = ({ label, value }) => {
  return (
    <div className="Info_Card">
      <h2>{label} </h2>
      <h4>{value} </h4>
    </div>
  );
};

export default Overview;
